import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * External link assets (migration 0024) — YouTube / Vimeo review.
 * Two steps: resolve a pasted URL to a preview (no row created), then create.
 */
export type LinkPreview = {
  provider: "youtube" | "vimeo";
  videoId: string;
  url: string;
  title: string;
  thumbnailUrl: string | null;
  durationSeconds: number | null;
};

/** POST /editor/link-preview — resolve URL → preview meta, no asset created. */
export function useLinkPreview() {
  return useMutation<LinkPreview, Error, { url: string }>({
    mutationFn: ({ url }) => api.post<LinkPreview>("/editor/link-preview", { url }),
  });
}

/** POST /editor/videos/from-link — create the link asset. Server re-resolves. */
export function useAddLink() {
  return useMutation<
    { ok: true; video: { id: string; title: string; sourceType: string } },
    Error,
    { projectId: string; url: string; folderId?: string | null }
  >({
    mutationFn: (body) => api.post("/editor/videos/from-link", body),
  });
}
